export const primaryFont = '"DM Sans", sans-serif';

export const typeScale = {
    header1: "6.375rem",//102
    header2: "4rem",//64
    header3: "3.188rem",//51
    header4: "2.250rem",//36
    header5: "1.563rem",//25
    header6: "1.3125rem",//21
    body: "1.125rem",//18
    subtitle: "1.063rem",//17
    subtitle1: "1rem",//16
    subtitle2: "0.938rem",//15
    button: "0.938rem", //15
    caption: "0.938rem", //15
    subtitle3: "0.875rem",//14
    helpText: "0.75rem", //12
    overline: "0.688rem", //11
    medium: "500",
    bold: "700"
}


export const lineHeight = {
    header1: "9.5625rem", //168
    header2: "6rem", //104
    header3: "4.782rem", //82
    header4: "3.375rem", //56
    header5: "2.3445rem", //41
    header6: "1.96875rem", //34
    subtitle: "1.5945rem", //28
    subtitle1: "1.407rem", //25
    subtitle2: "1.407rem", //25
    subtitle3: "1.21875rem", //22
    helpText: "1.125rem", //20
    button: "1.407rem", //25
    caption: "1.407rem", //25
    overline: "1.032rem", //18
}